import React from "react";
import NotificationList from "@/components/notifications/NotificationList";
import { Bell } from "lucide-react";

export default function ExternalNotifications() {
  return (
    <div data-testid="external-notifications-page">
      <h1 className="font-display text-xl font-bold flex items-center gap-2 mb-1 text-[#252221]">
        <Bell size={20} className="text-[#1C4358]" /> Notifications
      </h1>
      <p className="text-[13px] mb-5 text-muted-foreground">Updates from your MovingMyMama partner team.</p>
      <NotificationList variant="external" />
    </div>
  );
}
